module.exports = __webpack_public_path__ + "img/13-IP-interview-prep-for-people-with-disabilities.226b9fd8.svg";